import styled, { css } from 'styled-components'

import { FireButton } from '@nx/fire/button'
import { Body } from '@nx/fire/typography'

export const StyledFailedConnectionMessage = styled(Body)`
  ${({ theme }) => css`
    color: ${theme.colours.status.error};
    margin: 0;
  `}
`

export const StyledFireButton = styled(FireButton)`
  text-decoration: underline;
`
